import { useContext, useEffect, useState } from "react";
import Header from "../../../Components/Header/Header";
import Text from "../../../Components/FormControl/Text/Text";
// Context
import { AppContext } from "./../../../Context/AppContext";
import { getAccessByModuleName } from "./../../../Routes/Routes";
import { MODULES } from "./../../../Helpers/Constants";
// Services
import { getDesignerSettings, updateDesignerSettings } from "./../../../api/settings";
import _ from "lodash";
import SwitchBox from "../../../Components/FormControl/SwitchBox/SwitchBox";

const DesignerSetting = (props) => {
  const { showToastMessage, setIsLoading, modules } = useContext(AppContext);

  const [maxAllocation, setMaxAllocation] = useState(15);
  const [isRecipeRequired, setIsRecipeRequired] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [access, setAccess] = useState({});


  useEffect(() => {
    handleGetDesignerSetting();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);

  const onChange = (type, data) => {
    if (type === "maxAllocation") setMaxAllocation(data);
    if (type === "isRecipeRequired") setIsRecipeRequired(data);
  };

  function getModuleAccess() {
    let access = getAccessByModuleName(
      modules,
      MODULES.CONFIG_DESIGNER_SETTING
    );
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      window.location.href = "/dashboard";
    }
  }

  const handleGetDesignerSetting = async () => {
    setIsLoading(true);
    let response = await getDesignerSettings();

    if (response && response.status === 200) {
      setMaxAllocation(response.data.data.filter(item => item.key === "designer_max_task_allocation")[0]?.value);
      setIsRecipeRequired(Number(response.data.data.filter(item => item.key === "is_recipe_required")[0]?.value));
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setIsLoading(false);
  };

  const handleSubmitClick = async (event) => {
    let val = Number(maxAllocation);
    if (maxAllocation && maxAllocation <= 0) {
      showToastMessage(
        undefined,
        "Please enter valid positive number greater than 0",
        "error",
        false
      );
      event.preventDefault();
    } else if (maxAllocation && _.isInteger(val) == false) {
      showToastMessage(
        undefined,
        "Please enter valid integer number",
        "error",
        false
      );
      event.preventDefault();
    } else {
      event.preventDefault();
      setSubmitStatus(true);
      if (maxAllocation) {
        setIsLoading(true);
        let requestBody = [{
          key: "designer_max_task_allocation",
          value: maxAllocation,
        }, {
          key: "is_recipe_required",
          value: isRecipeRequired,
        }];

        let response = await updateDesignerSettings(requestBody);

        if (response && response.status === 200) {
          showToastMessage(undefined, response.data.message, "success", false);
          setSubmitStatus(false);
          handleGetDesignerSetting();
        } else {
          showToastMessage(undefined, response.data.message, "error", false);
        }
        setIsLoading(false);
      }
    }
  };

  return (
    <div>
      <Header title="Designer Setting" />
      <div className="row mt-4 mb-4">
        <div className={`col-md-6`}>
          <Text
            type="number"
            label="Max Allocation"
            value={maxAllocation}
            required={true}
            submitStatus={submitStatus}
            id="max_allocaton"
            onChange={(data) => onChange("maxAllocation", data)}
          />
        </div>
        <div className={`col-md-6`}>
          <div className="d-md-flex align-items-md-center">
            <label>Recipe Required</label> 
          </div>
          <SwitchBox
            value={isRecipeRequired}
            disabled={false}
            onChange={(data) => onChange("isRecipeRequired", data)}
          />
        </div>       
      </div>
      {access.write_access && (
        <a
          href="/"
          data-dismiss="modal"
          onClick={handleSubmitClick}
          className="btn gray-btn d-inline-block mb-3 mr-2"
        >
          {" "}
          Save{" "}
        </a>
      )}
    </div>
  );
};
export default DesignerSetting;
